import React, { createContext, useEffect, useState } from "react";

let MObilehandelrContext = createContext();

function Mobilehandelr({ children }) {
  let [isMobile, setismobile] = useState();
  let [openmenu, setopenmenu] = useState(false);

  let ismobilehandelr = (e) => {
    setismobile(e.matches);
  };

  useEffect(() => {
    window
      .matchMedia("(max-width: 1024px)")
      .addEventListener("change", ismobilehandelr);
    setismobile(window.matchMedia("(max-width: 1024px)").matches);
  }, []);

  return (
    <MObilehandelrContext.Provider value={{ isMobile, openmenu, setopenmenu }}>
      {children}
    </MObilehandelrContext.Provider>
  );
}
export { MObilehandelrContext, Mobilehandelr };
export default Mobilehandelr;
